import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
      <div class="poem">

        <p class="poem-block mb-3">
          Облетаем, <br/>
          Улетаем, <br/>
          Ветром сорваны, как листья с голых веток. <br/>
          Легкокрылы, <br/>
          Полны силы <br/>
          Были. Осень накидала чёрных меток,
        </p>

        <p class="poem-block mb-3">
          Потому что время наше вышло, <br/>
          Устарели навыки и знанья, <br/>
          Тихо меркнут прежние заслуги, <br/>
          Потому что не перелетишь ло- <br/>
          гических пределов мирозданья.
        </p>

        <p class="poem-block mb-3">
          Был живое – <br/>
          Стал в покое. <br/>
          И напрасно тёмное отчаяние. <br/>
          Слов потоки, <br/>
          Некрологи <br/>
          Отзвучали. Дальше – лишь молчание.
        </p>
      </div>
    `
  )
}

const itemName = {
  rus: 'В память об Анатолии Гончарове'
}

const item = {
  itemlink: getLink(itemName.rus),
  rus:{
    itemName: itemName.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}


export default item;